import { node } from "prop-types"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function BplsBasket({ children }) {
  return (
    <>
      <Row className="product d-flex align-items-center">
        <Col style={{ paddingLeft: 0 }}>{children?.[0]}</Col>
      </Row>

      <Row>
        <Col>
          <ul className="order-summary list-unstyled">{children?.[1]}</ul>
        </Col>
      </Row>

      <Row>
        <Col>
          <ul className="order-summary list-unstyled">{children?.[2]}</ul>
        </Col>
      </Row>
    </>
  )
}

BplsBasket.propTypes = {
  children: node
}
